/**
 * Who an edit of permissions affects (CT-5571). One `ScopeBanner` renders the matching text:
 * a role edit applies to every member with the role; a Studios edit is for ONE member.
 */
export const EDIT_SCOPE = Object.freeze({ ROLE: 'role', MEMBER: 'member' });
